// import Api from "./Api";
// import store from "../state/store";
import axios from "axios";
export default {
getUserOnlineCompliance(payload) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(`${payload.server_url}/api/get_online_compliance_user?visitCode=${payload.id}`
    ,{
      headers: headers,
    }
    ).then(response => {
      // console.log('service res', response);
      return Promise.resolve(response)
    })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
  },

  createUserOnlineCompliance(params) {
    return axios.post(`${params.server_url}/api/create_online_compliance_user`, params.obj)
    .then(response => {
      // console.log('service res', response);
      return Promise.resolve(response)
    })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
  },

  
};